import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { fetchOrderById } from "../api";
import { getStoredAuthToken } from "../authStorage";

export default function PaymentResponsePage({ setCart }) {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const status = searchParams.get("status");
    const orderId = searchParams.get("orderId");
    const message = searchParams.get("message");
    const [order, setOrder] = useState(null);

    useEffect(() => {
        if (status === "success") {
            setCart([]);
        }
    }, [setCart, status]);

    useEffect(() => {
        if (status === "success" && orderId) {
            const token = getStoredAuthToken();
            if (token) {
                fetchOrderById(orderId, token)
                    .then(setOrder)
                    .catch(() => {});
            }
        }
    }, [status, orderId]);

    const isSuccess = status === "success";
    const isCancelled = status === "cancelled";
    const orderCode = String(order?._id || order?.id || "").slice(-8).toUpperCase();
    const totalPaid = Number(order?.totalPrice || 0).toLocaleString("en-IN");

    return (
        <div style={{
            minHeight: "100vh", background: "#FDF5F5",
            display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center",
            padding: "60px 24px"
        }}>
            <div style={{ maxWidth: 520, width: "100%", textAlign: "center" }}>
                <div style={{
                    width: 80, height: 80, borderRadius: "50%",
                    background: isSuccess
                        ? "linear-gradient(135deg, #27ae60, #1e8449)"
                        : isCancelled
                            ? "linear-gradient(135deg, #f39c12, #d68910)"
                            : "linear-gradient(135deg, #e74c3c, #c0392b)",
                    display: "flex", alignItems: "center", justifyContent: "center",
                    fontSize: 36, margin: "0 auto 24px", color: "white",
                    boxShadow: isSuccess
                        ? "0 8px 32px rgba(39,174,96,0.3)"
                        : "0 8px 32px rgba(231,76,60,0.3)",
                    animation: "badgePop 0.5s both"
                }}>
                    {isSuccess ? "✓" : isCancelled ? "⏸" : "✕"}
                </div>

                <h1 style={{
                    fontFamily: "'Playfair Display',serif", fontSize: 34, fontWeight: 800,
                    marginBottom: 10, color: "#1a0a08"
                }}>
                    {isSuccess ? "Payment Successful! 🎉" : isCancelled ? "Payment Cancelled" : "Payment Failed"}
                </h1>

                <p style={{ color: "#7a5550", fontSize: 15, lineHeight: 1.75, marginBottom: 28 }}>
                    {isSuccess
                        ? "Your order has been placed successfully! You'll receive a confirmation email shortly."
                        : isCancelled
                            ? "You cancelled the payment. No charges were made. Feel free to try again."
                            : `We couldn't process your payment. ${message || "Please try again or contact support."}`}
                </p>

                {isSuccess && order && (
                    <div style={{
                        background: "white", borderRadius: 20, border: "1.5px solid #f0d0c8",
                        padding: 24, marginBottom: 28, boxShadow: "0 4px 18px rgba(192,57,43,0.08)",
                        textAlign: "left"
                    }}>
                        <div style={{ height: 3, background: "linear-gradient(90deg, #C0392B, #E8523A)", borderRadius: "4px 4px 0 0", margin: "-24px -24px 20px" }} />
                        <div style={{ fontSize: 12, color: "#b07878", fontWeight: 700, letterSpacing: "0.06em", marginBottom: 12 }}>ORDER DETAILS</div>
                        <div style={{ display: "flex", justifyContent: "space-between", fontSize: 13, marginBottom: 8 }}>
                            <span style={{ color: "#7a5550" }}>Order ID</span>
                            <span style={{ fontWeight: 700, color: "#1a0a08" }}>{orderCode}</span>
                        </div>
                        <div style={{ display: "flex", justifyContent: "space-between", fontSize: 13, marginBottom: 8 }}>
                            <span style={{ color: "#7a5550" }}>Items</span>
                            <span style={{ fontWeight: 700, color: "#1a0a08" }}>{order.orderItems?.length || 0}</span>
                        </div>
                        <div style={{ borderTop: "1.5px solid #f0d0c8", paddingTop: 12, display: "flex", justifyContent: "space-between", fontFamily: "'Playfair Display',serif", fontWeight: 800, fontSize: 16, marginTop: 8 }}>
                            <span style={{ color: "#1a0a08" }}>Total Paid</span>
                            <span style={{ color: "#C0392B" }}>₹{totalPaid}</span>
                        </div>
                    </div>
                )}

                <div style={{ display: "flex", gap: 12 }}>
                    <button
                        style={{
                            flex: 1, padding: "14px", fontSize: 14, fontWeight: 700,
                            background: "linear-gradient(135deg, #C0392B, #96221A)", color: "white",
                            border: "none", borderRadius: 10, cursor: "pointer",
                            fontFamily: "'Nunito Sans',sans-serif",
                            boxShadow: "0 4px 16px rgba(192,57,43,0.3)"
                        }}
                        onClick={() => navigate("/")}
                    >Go to Home</button>
                    {isSuccess ? (
                        <button
                            style={{
                                flex: 1, padding: "14px", fontSize: 14, fontWeight: 700,
                                background: "white", color: "#8B1A1A", border: "1.5px solid #f0d0c8",
                                borderRadius: 10, cursor: "pointer", fontFamily: "'Nunito Sans',sans-serif"
                            }}
                            onClick={() => navigate("/orders")}
                        >View My Orders</button>
                    ) : (
                        <button
                            style={{
                                flex: 1, padding: "14px", fontSize: 14, fontWeight: 700,
                                background: "white", color: "#8B1A1A", border: "1.5px solid #f0d0c8",
                                borderRadius: 10, cursor: "pointer", fontFamily: "'Nunito Sans',sans-serif"
                            }}
                            onClick={() => navigate("/checkout")}
                        >Try Again</button>
                    )}
                </div>
            </div>

            <style>{`
                @keyframes badgePop {
                    0% { transform: scale(0); opacity: 0; }
                    60% { transform: scale(1.15); }
                    100% { transform: scale(1); opacity: 1; }
                }
            `}</style>
        </div>
    );
}
